import * as React from 'react';

import type { TImagingDocumentType } from '../../utils';
import DEXAForm from './DEXA';
import CMAPForm from './CMAP';
import MuscleImagingForm from './MuscleImaging';
import EchocardiographyForm from './Echocardiography';
import ScoliosisForm from './Scoliosis';
import MriForm from './Mri';
import TTForm from './TT';
import ScintigraphyForm from './Scintigraphy';
import PelvisForm from './Pelvis';
import ThymusCTForm from './ThymusCT';
import ThymusMRIForm from './ThymusMRI';
import NerveUltrasoundForm from './NerveUltrasound';

const ImagingForm = ({ formData, document }: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'dexa':
      return <DEXAForm formData={formData} />;
    case 'cmap':
      return <CMAPForm formData={formData} />;
    case 'muscleImaging':
      return <MuscleImagingForm formData={formData} />;
    case 'echocardiography':
      return <EchocardiographyForm formData={formData} />;
    case 'scoliosis':
      return <ScoliosisForm formData={formData} />;
    case 'pelvis':
      return <PelvisForm formData={formData} />;
    case 'mri':
      return <MriForm formData={formData} />;
    case 'tt':
      return <TTForm formData={formData} />;
    case 'scintigraphy':
      return <ScintigraphyForm formData={formData} />;
    case 'thymusCt':
      return <ThymusCTForm formData={formData} />;
    case 'thymusMri':
      return <ThymusMRIForm formData={formData} />;
    case 'nerveUltrasound':
      return <NerveUltrasoundForm formData={formData} />;
    default:
      return null;
  }
};
interface IOwnProps {
  formData: IFormData;
  document?: IDocumentWithTypeV2<TImagingDocumentType>;
  viewing?: boolean;
}

export default ImagingForm;
